module.exports = __webpack_public_path__ + "assets/postpone.cd076f2d8b0b24d795617bf19ed2f648.svg";